import { EventPayloadCrud } from '../../../controller-classes';
import { getKitchenReferenceRules } from '../helpers';
import { ReferenceMap } from '../../public.types';
import { RuleScope } from '../constants/rule-scope';
import { RulesEngine } from '../rules-engine.class';
import { rulesMap } from '../rules/rules-map';
import { toCamelCase } from '../../../helpers';
import { validationsMap } from '../validations/validations-map';

export const applyActionRulesCfn = (rulesEngine: RulesEngine, ruleScope: number, params: EventPayloadCrud<unknown, ReferenceMap>): void => {
	const itemRules = getKitchenReferenceRules({ ruleScope, refMap: params.ref });
	// console.log('rule:applyActionRulesCfn', { itemRules });
	// let validationScope = RuleScope.Lowest;

	for (const itemRule of itemRules.action) {
		if (itemRule) {
			const rule = rulesMap[toCamelCase(itemRule)] ?? null;

			if (rule) {
				// console.log('rule:validate action rules', itemRule, params);
				// if (rule.scope < validationScope) validationScope = rule.scope;
				rule.func({ refMap: params.ref });
			} else {
				console.warn(`rule:action:-- ${itemRule}`, 'invalid rule')
			}
		}
	}
	// Apply Validation Rules
	for (const itemVal of itemRules.validation) {
		if (itemVal) {
			const val = validationsMap[toCamelCase(itemVal)] ?? null;

			if (val) {
				// console.log('rule:validate validation rules', itemVal, params);
				val.func({ refMap: params.ref });
			} else {
				console.warn(`rule:validation:-- ${itemVal}`, 'invalid validation rule');
			}
		}
	}

	// applyValidationRules(params, validationScope);
};

